import { Box, Typography } from "@dealer-center/core-components";

export const AutoRespondersPage = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h6">Auto Responders</Typography>
    <Typography sx={{ color: "text.secondary", mt: 1 }} variant="body-md">
      TODO: implement Auto Responders
    </Typography>
  </Box>
);
